<script>
import Quantity from "./quantity.svelte";
export let maxValue = 6;
export let page = "home";
export let params ={};
let rectValue = 1+Math.floor(Math.random()*(maxValue-1));
let diceValue = 1+Math.floor(Math.random()*(maxValue-1));
let heapValue = 1+Math.floor(Math.random()*(maxValue-1));
let discValue = 1+Math.floor(Math.random()*(maxValue-1));
let randgridValue = 1+Math.floor(Math.random()*(maxValue-1));
let randheapValue = 1+Math.floor(Math.random()*(maxValue-1));
</script>

<h1 align=center>
	InCA-WhatIsMore
</h1>

A simple web solution to compare the ability of  animals in comparing discrete  and continuous  quantities with distinct color settings.

<table align="center"><tr>
<td on:click={()=>{params.mode="rect";page="game"}}>
	<Quantity n={rectValue} mode="rect" 
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td>
<td on:click={()=>{params.mode="dice";page="game"}}>
	<Quantity n={diceValue} mode="dice" 
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td>
<td on:click={()=>{params.mode="heap";page="game"}}>
	<Quantity n={heapValue} mode="heap" 
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td>
<td on:click={()=>{params.mode="disc";page="game"}}>
	<Quantity n={discValue} mode="disc" 
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td>
<!-- <td on:click={()=>{params.mode="randgrid";page="game"}}>
	<Quantity n={randgridValue} mode="randgrid" 
						gridSize={params.gridSize}
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td>
<td on:click={()=>{params.mode="randheap";page="game"}}>
	<Quantity n={randheapValue} mode="randheap"
						gridSize={params.gridSize}
						fg={params.fg}
						bg={params.bg}												  
						bg_opacity={params.bg_opacity}></Quantity></td> -->
</tr>	
</table>

<div ALIGN=RIGHT>
	InCA Labs
</div>
	